import React, { createContext, useState, useEffect, useContext } from 'react';
import { message } from 'antd';
import matchProducts from '../services/matchProducts';
import filterArrays from '../utils/filterArrays';
import useApi from '../hooks/useApi';
import { AccountContext } from './AccountContext';

export const ProductsContext = createContext();

export const ProductsProvider = ({ children }) => {
  const { callApi } = useApi();
  const account = useContext(AccountContext);
  const clientInfo = account?.clientInfo;
  const [productsClient, setProductsClient] = useState([]);
  const [productsMissing, setProductsMissing] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (account?.clientLoading) {
      setLoading(true);
      return;
    }

    const fetchProducts = async () => {
      setLoading(true);
      try {
        const [clientResponse, products] = await matchProducts(
          callApi,
          clientInfo || null
        );
        const catalog = products?.results || [];
        setAllProducts(catalog);

        if (!clientInfo) {
          setProductsClient([]);
          setProductsMissing(catalog);
          return;
        }

        if (
          !clientResponse?.results?.products ||
          clientResponse.results.products.length === 0
        ) {
          setProductsMissing(catalog);
        }
        const [arrOwn, arrMissing] = filterArrays(
          clientResponse?.results?.products || [],
          catalog
        );
        setProductsClient(arrOwn);
        setProductsMissing(arrMissing);
      } catch (error) {
        message.error('Ha ocurrido un error al cargar los productos');
        console.error('ProductsContext: Error fetching products:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [callApi, clientInfo, account?.clientLoading]);

  return (
    <ProductsContext.Provider
      value={{
        productsClient,
        productsMissing,
        allProducts,
        loading,
      }}
    >
      {children}
    </ProductsContext.Provider>
  );
};
